import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createProductCategory,
  updateProductCategory,
} from "../../../apis/productCategory";
import { missingPopup } from "../../../helperFunctions/missingFieldToast";
import { toastify } from "../../../helperFunctions/toastify";

export default function AddEditProductCategory() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const populateData = async () => {
    setName(state?.productCategory?.name);
    setDescription(state?.productCategory?.description);
  };

  const saveKol = async () => {
    if (!name) {
      missingPopup("Name");
    } else {
      if (!state?.productCategory) {
        const response = await createProductCategory({ name, description });
        if (response?.status !== "Fail") {
          toastify("Product Category added successfully!", "success");
          navigate("/product-category");
        } else {
          toastify(response?.message, "error");
        }
      } else {
        const response = await updateProductCategory(
          state?.productCategory?._id,
          { name, description }
        );
        if (response?.status !== "Fail") {
          toastify("Product Category updated successfully!", "success");
          navigate("/product-category");
        } else {
          toastify(response?.message, "error");
        }
      }
    }
  };

  useEffect(() => {
    if (state?.productCategory) populateData();
  }, []);

  return (
    <React.Fragment>
      <div className="mainHeading px-4">
        <h1>
          <i
            className="fa fa-arrow-left cursor-pointer"
            onClick={() => navigate(-1)}
          ></i>
          {`${state?.productCategory ? "Edit " : "New "}`}
          Product Category (Inventory)
        </h1>
      </div>
      <div className="pb-4 px-4">
        <div className="content">
          <div className="addEdit pb-4">
            <div className="row">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="headings2">Name *</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Write..."
                      maxLength={30}
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="headings2">Description</Form.Label>
                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      placeholder="Write..."
                      style={{ resize: "none" }}
                      maxLength={50}
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                      className="large-text-area"
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="addEdit">
            <Button className="addItem" onClick={saveKol}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
